/* Farren Tweaks Panel — vanilla JS controller */
(function() {
  'use strict';

  // Aktif: ?tweaks=1 URL parametresi VEYA always_visible setting
  const params = new URLSearchParams(window.location.search);
  const wantsTweaks = params.get('tweaks') === '1' || params.get('tweaks') === 'true';
  const forceShow = document.querySelector('.farren-tweaks[data-show="true"]');

  if (!wantsTweaks && !forceShow) return;

  document.addEventListener('DOMContentLoaded', initTweaks);
  if (document.readyState !== 'loading') initTweaks();

  function initTweaks() {
    const root = document.querySelector('.farren-tweaks');
    if (!root) return;
    root.classList.add('is-revealed');

    const toggle = root.querySelector('.farren-tweaks__toggle');
    const panel = root.querySelector('.farren-tweaks__panel');
    const closeBtn = root.querySelector('.farren-tweaks__close');

    // Toggle açma
    toggle?.addEventListener('click', () => {
      root.classList.add('is-open');
      panel?.removeAttribute('hidden');
    });
    closeBtn?.addEventListener('click', () => {
      root.classList.remove('is-open');
      panel?.setAttribute('hidden', '');
    });

    // Restore from localStorage
    const stored = JSON.parse(localStorage.getItem('farren-tweaks') || '{}');

    // Palette dropdown
    const paletteSelect = root.querySelector('[data-tweak="palette"]');
    if (paletteSelect) {
      paletteSelect.value = stored.palette || 'mothers-day';
      applyPalette(paletteSelect.value);
      paletteSelect.addEventListener('change', (e) => {
        applyPalette(e.target.value);
        save('palette', e.target.value);
      });
    }

    // Banner toggle
    const bannerInput = root.querySelector('[data-tweak="banner"]');
    if (bannerInput) {
      bannerInput.checked = stored.banner !== false;
      applyBanner(bannerInput.checked);
      bannerInput.addEventListener('change', (e) => {
        applyBanner(e.target.checked);
        save('banner', e.target.checked);
      });
    }

    // Segmented controls (hero-layout, card-style, display-font)
    root.querySelectorAll('[data-seg]').forEach((seg) => {
      const segName = seg.dataset.seg;
      const buttons = seg.querySelectorAll('button[data-val]');

      // Restore active
      const storedVal = stored[segName];
      if (storedVal) {
        buttons.forEach(b => b.classList.toggle('is-active', b.dataset.val === storedVal));
        applySeg(segName, storedVal);
      } else {
        const initial = seg.querySelector('button.is-active')?.dataset.val;
        if (initial) applySeg(segName, initial);
      }

      buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
          buttons.forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          applySeg(segName, btn.dataset.val);
          save(segName, btn.dataset.val);
        });
      });
    });
  }

  function save(key, value) {
    const stored = JSON.parse(localStorage.getItem('farren-tweaks') || '{}');
    stored[key] = value;
    localStorage.setItem('farren-tweaks', JSON.stringify(stored));
  }

  function applyPalette(palette) {
    document.body.dataset.farrenPalette = palette;
  }

  function applyBanner(visible) {
    const bar = document.querySelector('.farren-campaign-bar');
    if (!bar) return;
    bar.style.display = visible ? '' : 'none';
  }

  function applySeg(name, val) {
    if (name === 'hero-layout') {
      const hero = document.querySelector('.farren-hero');
      if (!hero) return;
      hero.classList.remove('farren-hero--cutout', 'farren-hero--fullbleed');
      hero.classList.add('farren-hero--' + val);
    }
    if (name === 'card-style') {
      document.body.dataset.farrenCardStyle = val;
    }
    if (name === 'display-font') {
      const root = document.documentElement;
      if (val === 'bodoni') {
        root.style.setProperty('--farren-font-display', "'Bodoni Moda', 'Didot', serif");
      } else {
        root.style.removeProperty('--farren-font-display');
      }
    }
  }
})();
